var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-medal-dialog-container" },
    [
      _vm.showDialog
        ? _c("medal-dialog-container", {
            ref: "dialog",
            attrs: { appName: _vm.appName, medalList: _vm.medalList },
            on: { closeDialog: _vm.close },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }